export const ACTIVITY_TYPE_SLUG = {
  PHONE_CALL: 'call',
  SMS: 'sms',
  VOICEMAIL: 'voicemail',
  EMAIL: 'email',
  SHOP_REQUEST_STATUS_CHANGE: 'shop-request-status-change',
  CALL_ATTEMPT: 'call_attempt',
  CALL_CONNECTED: 'call_connected',
  WEB_FORM_SUBMITTED: 'web_form_submitted',
} as const;

export const ACTIVITY_DIRECTION_TYPE = {
  INBOUND: 1,
  OUTBOUND: 2,
  UNKNOWN: 3,
  INTERNAL: 4,
} as const;

export const ACTIVITY_CATEGORY = {
  COMMUNICATION: 'communication',
} as const;

export const ACTIVITY_EMAIL_RECIPIENT_ROLE = {
  FROM: 'from',
  TO: 'to',
  CC: 'cc',
  BCC: 'bcc',
  REPLY_TO: 'reply_to',
} as const;
